import type { StepRegistry } from '../StepRegistry';
import { wait } from './utils';

export function registerWeatherSteps(registry: StepRegistry): void {
  registry.register('weather', async (step, systems) => {
    if (step.params.type === 'storm') {
      await systems.weather.setStorm(step.duration);
    } else {
      await systems.weather.setClear(step.duration);
    }
  });

  registry.register('storm-ripple', async (step, systems) => {
    systems.effects.startStormRipple();
    await wait(step.duration);
    systems.effects.stopStormRipple();
  });
}
